import type { Component, Entity2D } from '../../odie';

import type { ShieldBubbleBlockProps } from '../defs/block';
import { ShieldBubbleBlockView } from '../views/blocks/ShieldBubbleBlockView';

export type ShieldBubbleBlockComponentOptions = {
  props: ShieldBubbleBlockProps;
};

export class ShieldBubbleBlockComponent implements Component {
  public static readonly NAME = 'blockShieldBubble';
  public entity!: Entity2D;
  public view!: ShieldBubbleBlockView;

  public init(options: ShieldBubbleBlockComponentOptions): void {
    this.view = new ShieldBubbleBlockView(options.props);
  }
}
